import '@take-2/views/desktop/shared/_marketingSpotlight.js';
import '@take-2/views/home/partials/desktop/_theatersModule.js';
import '@take-2/views/home/partials/desktop/_theatersModuleCardsPlaceholder.js';
import '@fd-assets/carousel/views/shared/partials/_movieCarousel.js';
import '@take-2/views/home/partials/desktop/_errorMessage.js';
import '@take-2/views/home/partials/desktop/_noShowtimes.js';
